import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';

@Component({
  selector: 'customer-app-equity-sub-title',
  templateUrl: './equity-sub-title.component.html',
  styleUrls: ['./equity-sub-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class EquitySubTitleComponent implements EquityPageComponentModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;
}
